import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-accent)";

function IconLock({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="m5.963 5.75-.001-.035c-.008-.35.008-.83.112-1.32.104-.485.304-1.02.693-1.438.404-.436.977-.707 1.734-.707s1.33.271 1.733.707c.39.419.59.953.693 1.438.105.49.121.97.113 1.32l-.001.035H12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h.963zm4.075 0 .002-.059c.007-.305-.008-.7-.09-1.086-.084-.39-.228-.73-.448-.968-.206-.22-.508-.387-1.001-.387-.493 0-.796.166-1.001.387-.22.237-.364.578-.448.968a4.774 4.774 0 0 0-.089 1.145h3.075zM5 6.75h7v6H5v-6z"/>
        </svg>

    );
}

export default IconLock;

